
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';

const __default__ = defineComponent({
  emits: ['update:modelValue', 'closeModal'],
  props: {
    modelValue: { type: Boolean, default: false },
    width: { type: String, default: '900px' },
  },
  mounted() {
    this.modal = new Modal(this.$refs.modalDialog, {
      backdrop: 'static',
      keyboard: false,
    });
  },
  data() {
    return {
      modal: null,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },

  methods: {
    handleClose() {
      this.$emit('closeModal');
    },
  },
  watch: {
    dialog(value) {
      if (value) {
        (this.modal as any)?.show();
      } else {
        (this.modal as any)?.hide();
      }
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "7ef75e41": (_ctx.width)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__